import BaseApi from './BaseApi'

export default class ReportsApi extends BaseApi {
    async getOverSpeedReport (params = {
        fleetId: null,
        vehicleId: null,
        dateFrom: null,
        dateTo: null
    }) {
        const request = new URLSearchParams()

        if (params.fleetId && !params.vehicleId) {
            request.append('FleetId', params.fleetId)
        }

        if (params.vehicleId) {
            request.append('VehicleId', params.vehicleId)
        }

        if (params.dateFrom) {
            request.append('DateFrom', params.dateFrom)
        }

        if (params.dateTo) {
            request.append('DateTo', params.dateTo)
        }

        return this.get('/api/v1.0/reports/overSpeedReport', request)
    }
    async getJourneysReport (params = {
        fleetId: null,
        vehicleId: null,
        dateFrom: null,
        dateTo: null
    }) {
        const request = new URLSearchParams()

        if (params.fleetId) {
            request.append('FleetId', params.fleetId)
        }

        if (params.vehicleId) {
            request.append('VehicleId', params.vehicleId)
        }

        if (params.dateFrom) {
            request.append('DateFrom', params.dateFrom)
        }

        if (params.dateTo) {
            request.append('DateTo', params.dateTo)
        }

        return this.get('/api/v1.0/reports/journeysReport', request)
    }
    async getEventsReport (params = {
        fleetId: null,
        vehicleId: null,
        dateFrom: null,
        dateTo: null,
        includeMediaUris: null
    }) {
        const request = new URLSearchParams()

        if (params.fleetId) {
            request.append('FleetId', params.fleetId)
        }

        if (params.vehicleId) {
            request.append('VehicleId', params.vehicleId)
        }

        if (params.dateFrom) {
            request.append('DateFrom', params.dateFrom)
        }

        if (params.dateTo) {
            request.append('DateTo', params.dateTo)
        }

        if (undefined !== params.includeMediaUris && null !== params.includeMediaUris) {
            request.append('IncludeMediaUris', params.includeMediaUris.toString())
        }

        return this.get('/api/v1.0/reports/eventsReport', request)
    }
    async getDevicesReport (params = {
        fleetId: null,
        vehicleId: null,
        dateFrom: null,
        dateTo: null
    }) {
        const request = new URLSearchParams()

        if (params.fleetId) {
            request.append('FleetId', params.fleetId)
        }

        if (params.vehicleId) {
            request.append('VehicleId', params.vehicleId)
        }

        return this.get('/api/v1.0/reports/devicesReport', request)
    }
}
